<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-product-returns-webshop *ngSwitchDefault></app-product-returns-webshop>  
</ng-container>
